import { render, staticRenderFns } from "./NewsBody.vue?vue&type=template&id=30ba94af&scoped=true&"
import script from "./NewsBody.vue?vue&type=script&lang=js&"
export * from "./NewsBody.vue?vue&type=script&lang=js&"
import style0 from "./NewsBody.vue?vue&type=style&index=0&id=30ba94af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ba94af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30ba94af')) {
      api.createRecord('30ba94af', component.options)
    } else {
      api.reload('30ba94af', component.options)
    }
    module.hot.accept("./NewsBody.vue?vue&type=template&id=30ba94af&scoped=true&", function () {
      api.rerender('30ba94af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Press/News/NewsBody.vue"
export default component.exports